import Page from "../components/common/page";
import Hero from "../components/home/hero";
import MetaStrip from "../components/home/metaStrip";
import Position from "../components/home/position";
import SelectedWork from "../components/home/selectedWork";
import BooksSection from "../components/home/booksSection";
import RecentPapers from "../components/home/recentPapers";
import Teaching from "../components/home/teaching";

const Homepage = () => (
	<Page page="home">
		<Hero />
		<MetaStrip />
		<Position />
		<SelectedWork />
		<BooksSection />
		<RecentPapers />
		<Teaching />
	</Page>
);

export default Homepage;
